var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "atom/icon/edit/default")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clickable-Mockup-(ENG)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DASHBOARD->-Overview-V3",
    transform: "translate(-255.000000, -441.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "organism/Card-workbench",
    transform: "translate(163.000000, 261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(92.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/edit/press",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 3.000000)",
    stroke: "#1F5DEA",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 L1.24137931,0 C1.24137931,0 0,0 0,1.24137931 L0,16.7586207 C0,16.7586207 0,18 1.24137931,18 L16.7586207,18 C16.7586207,18 18,18 18,16.7586207 L18,9",
    id: "Stroke-7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(7.000000, 0.000000)",
    fill: "#1F5DEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 11.1650414 0 14 2.83496755 14 11.2 5.63495858 8.36503245 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7675669,2.08796828 L11.9120137,0.232439336 C11.6020968,-0.0774797786 11.097476,-0.0774797786 10.787559,0.232439336 L9.33333333,1.68667518 L12.313304,4.66666667 L13.7675297,3.21243082 C14.0774839,2.90251171 14.0774839,2.3978874 13.7675669,2.08796828 Z",
    id: "Path"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.f2474ce3.svg";
export { ForwardRef as ReactComponent };